module.exports = __webpack_public_path__ + "0a235482b63cf983a9dff4ba638ba2dd.pdf";